import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

type AutocompleteDropdownProps<T> = {
  options: Array<T>;
  nameProp: string;
  keyProp: string | number;
  label: string;
  name?: string; // Not used
  value?: T | null;
  error?: boolean;
  loading?: boolean;
  required?: boolean;
  emptyLabel?: string;
  placeholder?: string;
  callback: (selected: T | null) => void;
  componentWidth?: string;
  disable?: boolean;
};

export const AutocompleteDropdown = <T,>(props: AutocompleteDropdownProps<T>) => {
  const {
    options,
    nameProp,
    keyProp,
    label,
    value = '',
    error = false,
    loading = false,
    required = false,
    emptyLabel = 'common:button.all',
    placeholder = undefined,
    callback,
    componentWidth = '15rem',
    disable,
  } = props;
  const { t } = useTranslation(['common']);
  const [localValue, setLocalValue] = useState<T | null>({ [nameProp]: t(emptyLabel || 'common:button.all') } as unknown as T);
  const [inputValue, setInputValue] = useState('');
  const componentId = `autocomplete-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  useEffect(() => {
    if (value) {
      setLocalValue(value);
      setInputValue(value[nameProp]);
    }
  }, [value, nameProp]);

  const setPlaceholder = () => {
    const hasInputValue = inputValue && inputValue.length > 0;
    if (hasInputValue) return undefined;
    return placeholder || t('common:form.all');
  };

  return (
    <Autocomplete
      value={localValue}
      id={componentId}
      options={options}
      disabled={disable}
      autoHighlight
      sx={{ minWidth: componentWidth }}
      getOptionLabel={(option) => option[nameProp] || ''}
      onChange={(event: any, newValue: T | null) => {
        setLocalValue(newValue);
        setInputValue((newValue && newValue[nameProp]) || '');
        callback(newValue);
      }}
      isOptionEqualToValue={(option, val) => {
        // ConsoleHelper.log('isOptionEqualToValue', option, val, nameProp);
        return val[nameProp] === t('common:button.all') || (placeholder && val[nameProp] === placeholder) || option[keyProp] === val[keyProp];
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      loading={loading}
      renderOption={(propz, option) => {
        return (
          <Box component='li' {...propz} key={option[keyProp]}>
            {option[nameProp]}
          </Box>
        );
      }}
      // getOptionDisabled={(option) =>
      //   option === XXX || option === XXX
      // }
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          placeholder={setPlaceholder()}
          label={label}
          error={error}
          required={required}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};
